import React from "react";

function Loader() {
  return (
    <section className="loader3 fixed top-0 left-0 h-[100vh] w-full bg-black z-[100] flex justify-center items-center">
      <section className="loader fixed top-0 left-0 h-[100vh] w-full bg-black z-[100] flex justify-center items-center flex-col">
        <h1 className="text-white text-[80px] max-md:text-[70px] max-sm:text-[50px] text-end ">
          Karim
        </h1>
        <br />
      </section>
      <section className="loader2 fixed top-0 left-0 h-[100vh] w-full bg-white z-[80] flex justify-center items-center ">
        <h1 className=" text-black text-[100px] max-md:text-[70px] max-sm:text-[50px] text-center ">
          Dreamer
        </h1>
      </section>
      <h1 className=" text-white text-[100px] max-md:text-[70px] max-sm:text-[50px] text-center ">
        Unique
      </h1>
    </section>
  );
}

export default Loader;
